// extracted by mini-css-extract-plugin
export var background = "Stars-module--background--ItCIM";
export var foreground = "Stars-module--foreground--YY0DE";
export var star = "Stars-module--star--Umll4";
export var stars = "Stars-module--stars--02loS";